<template>
    <v-dialog max-width="1200px" v-model="dialog" persistent>
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title style="padding-left: 0px">
                    Lịch sử yêu cầu sửa chữa
                </v-toolbar-title>
            </v-toolbar>
            <v-btn
                @click="close"
                icon
                style="position: absolute; right: 10px; top: 10px; color: #fff"
            >
                <v-icon>cancel</v-icon>
            </v-btn>
            <v-card-text>
                <v-layout wrap style="padding: 10px;">
                    <v-flex xs12 sm12 md6>
                        <p class="font-weight-bold">
                            Mã quản lý:
                            {{ fixedAssetsCode }}
                        </p>
                        <p class="font-weight-bold">
                            Tên tài sản:
                            {{ fixedAssetsName }}
                        </p>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                        <p class="font-weight-bold">
                            Bộ phận sử dụng hiện tại:
                            {{ departmentName }}
                        </p>
                        <p class="font-weight-bold">
                            Địa điểm sử dụng hiện tại:
                            {{ locationName }}
                        </p>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-text>
                <table class="lstTable" v-if="lstHistory.length > 0">
                    <tr>
                        <th width="15%">STT</th>
                        <th>Số đề nghị</th>
                        <th>Ngày đề nghị</th>
                        <th>Trạng thái</th>
                    </tr>
                    <template v-for="(item, k) in lstHistory">
                        <tr :key="k">
                            <td style="text-align: center;">{{ k+1 }}</td>
                            <td style="text-align: center;">{{item.repairRequestCode}}</td>
                            <td style="text-align: center;">{{item.createdAt|formatDate}}</td>
                            <td style="text-align: center;">{{ requestStatus(item.status) }}</td>
                        </tr>
                    </template>
                </table>
                <div v-else style="border:1px solid grey;border-radius: 10px;padding: 10px">Không có lịch sử
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="close">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.close") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import CSearchForm from "../../../components/form/ManageForm";
import axios from "axios";
import { requestConstants } from "@/constants";

export default {
    name: "repair-request-history",
    components: { CSearchForm },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        propsItem: {
            type: Object,
            default: ()=> {}
        },
        backTo: {
            type: String,
            default: '',
        },
        lstLocation: {
            type: Array,
            default: ()=> []
        },
        lstDepartment: {
            type: Array,
            default: ()=> []
        },
    },
    data: () => {
        return {
            lstHistory: [],
            fixedAssetsId: '',
            fixedAssetsName: '',
            fixedAssetsCode: '',
            locationName: '',
            departmentName: '',
        };
    },
    watch: {
        propsItem: {
            handler(value) {
                console.log(value);
                if (value !== null) {
                    this.fixedAssetsId = value.fixedAssetsId;
                    this.fixedAssetsName = value.name;
                    this.fixedAssetsCode = value.code;
                    this.getHistory(value.fixedAssetsId);

                    if (value.locationId != null) {
                        const location = this.lstLocation.find(o => o.categoryId === value.locationId );
                        if (location !== undefined && typeof location == 'object') {
                            this.locationName = location.categoryName;
                        }
                    }

                    if (value.departmentId != null) {
                        const department = this.lstDepartment.find(o => o.deptId === value.departmentId );
                        if (department !== undefined && typeof department == 'object') {
                            this.departmentName = department.deptName;
                        }
                    }
                } else {
                    this.fixedAssetsName = '';
                    this.fixedAssetsCode = '';
                    this.locationName = '';
                    this.departmentName = '';
                    this.fixedAssetsId = '';
                    this.lstHistory = [];
                }
            },
            deep: true,
        },
    },
    created() {
        
    },
    computed: {

    },
    methods: {
        close() {
            this.$emit("close");
        },
        getHistory(fixedAssetsId) {
            axios.post(process.env.VUE_APP_API_URL + "/repairRequest/search?pageSize=-1&page=-1&sortField=createdAt&orderBy=desc", {fixedAssetsId: fixedAssetsId})
            .then(
                (data) => {
                    if (data.items) {
                        this.lstHistory = data.items;
                    }
                }
            );
        },
        requestStatus(value) {
            let status = '';
            let itemStatus = requestConstants.repairRequestStatus.find(function (e) {
                return e.value == value;
            });
            if (itemStatus != undefined) {
                status = itemStatus.text;
            }
            return status;
        },
    },
    destroyed() {},
};
</script>
